// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { getUserSegmentationData } from '../../services/user-profile/index.tsx';
import type { State } from './types.tsx';
import { mapUserTeamTypeToTeamType } from './utils.tsx';

const loadPersonalisedAppsUserSegmentation =
	(): Action<State> =>
	async ({ setState }) => {
		const promise = getUserSegmentationData();

		setState({
			error: null,
			isLoading: true,
			isSuccess: false,
			promise,
		});

		try {
			const { team } = await promise;
			const teamType = mapUserTeamTypeToTeamType(team);
			setState({
				teamType,
				isSuccess: true,
				hasSuccessOnce: true,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				error,
			});
		} finally {
			setState({
				isLoading: false,
			});
		}
	};

export const actions = {
	loadPersonalisedAppsUserSegmentation,
} as const;
